import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManagementViewComponent } from './management-view/management-view.component';
import { ManagementViewBreadcrumbResolver } from './management-view-breadcrumb.resolver';
import {
  CartridgeMembersOverviewBreadcrumbResolver,
  CartridgeMembersOverviewCartridgeVariantIdResolver,
  CartridgeMembersOverviewComponent,
  CartridgeMembersOverviewOrganizationIdResolver,
} from '@markant-platform/shared/cartridge/feature-cartridge-members-overview';
import { AuthorizationRouteGuard } from '@markant-platform/shared/route-guard/feature';
import { StaticRole } from '@markant-platform/shared/user/model';
import { UsageReportGuard } from '@markant-platform/shared/usage/feature';
import { OrganizationMemberDetailsBreadcrumbResolver } from '@markant-platform/shared/organization/resolver';
import { OrganizationMemberDetailsRouting } from '@markant-platform/shared/organization/feature';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthorizationRouteGuard(StaticRole.ORGANIZATION_ADMIN, StaticRole.PLATFORM_ADMIN)],
    resolve: {
      subBreadcrumbs: ManagementViewBreadcrumbResolver,
    },
    children: [
      {
        path: '',
        component: ManagementViewComponent,
      },
      {
        path: ':cartridgeId/employees',
        resolve: {
          subBreadcrumbs: CartridgeMembersOverviewBreadcrumbResolver,
        },
        children: [
          {
            path: '',
            component: CartridgeMembersOverviewComponent,
            resolve: {
              organizationIdFromBooking: CartridgeMembersOverviewOrganizationIdResolver,
            },
          },
          {
            path: ':userId',
            resolve: {
              subBreadcrumbs: OrganizationMemberDetailsBreadcrumbResolver,
            },
            children: OrganizationMemberDetailsRouting,
          },
        ],
      },
      {
        path: 'usages',
        canActivate: [UsageReportGuard],
        data: {
          translationKey: 'usageInformation',
        },
        loadComponent: () => import('@markant-platform/usage/feature-usage-report').then(m => m.UsageReportComponent),
      },
      {
        path: 'documents',
        data: {
          translationKey: 'documentsOverviewBreadCrumb',
        },
        resolve: {
          cartridgeVariantIdFromBooking: CartridgeMembersOverviewCartridgeVariantIdResolver,
        },
        loadChildren: () =>
          import('@markant-platform/backoffice/feature-documents-overview').then(
            m => m.BackofficeFeatureDocumentsOverviewModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CartridgeFeatureManagementViewRoutingModule {}
